"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFinalForm = require("react-final-form");

var _TextFieldAdapter = _interopRequireDefault(require("../../Adapters/TextFieldAdapter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

//  Multiline textfield with min and max lengths and number or rows
var MultiLineField = function MultiLineField(props) {
  var required = props.required,
      name = props.name,
      label = props.label,
      minlength = props.minlength,
      maxlength = props.maxlength,
      rows = props.rows;

  if (required === undefined) {
    required = true;
  }

  if (name === undefined) {
    name = "field";
  }

  if (label === undefined) {
    label = "Field";
  }

  if (minlength === undefined) {
    minlength = 1;
  }

  if (maxlength === undefined) {
    maxlength = 1000;
  }

  if (rows === undefined) {
    rows = 1;
  }

  var isValid = function isValid(x) {
    //const re = /^[ "&-.0-:A-Za-z\u0080-\uFFFF]{10,5000}$/;
    var re = RegExp("^[ &-.0-:A-Za-z\x80-\uFFFF]{" + minlength.toString() + "," + maxlength.toString() + "}$");
    return (x || !required) && (re.test(x) || !required && (x === undefined || (x === null || x === void 0 ? void 0 : x.length) === 0)) ? undefined : "Enter a valid " + name;
  };

  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, _extends({
    name: name,
    validate: isValid,
    required: required,
    label: label,
    component: _TextFieldAdapter.default,
    subscription: {
      touched: true,
      value: true,
      error: true
    },
    fullWidth: true,
    inputProps: {
      maxLength: maxlength
    },
    multiline: true,
    rows: rows
  }, props));
};

var _default = MultiLineField;
exports.default = _default;